import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'tm-checkbox',
  templateUrl: './tm-checkbox.component.html',
  styleUrls: ['./tm-checkbox.component.scss']
})
export class TmCheckboxComponent implements OnInit {

  @Input() form_group: UntypedFormGroup;
  @Input() form_control;
  @Input() label;
  @Input() data;
  @Input() actionListner;
  @Input() mandatory;
  @Input() disabled;
  @Input() enable_active;
  @Input() ng_class;
  random_id = 'tm_multi_select_checkbox' + Math.floor((Math.random() * 10000) + 1) + Date.now();

  @Output() change = new EventEmitter<any>()
  constructor(
    private change_detector: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
  }
  ngOnChanges(ev) {

    if (ev && ev.data) {
      this.data = ev.data.currentValue;
      if (typeof this.data == "string") {
        try {
          this.data = JSON.parse(this.data);
          if (this.data && this.data.length) {
            let d = []
            this.change.emit(d);
          } else {
            this.change.emit([]);
          }
        }
        catch (err) {
          console.log(err)
        }
      }
      else {
        if (this.data && this.data.length) {
          let d = []
          this.change.emit(d);
        }
        else {
          this.change.emit([]);
        }
      }
    }

  }
  onSelect() {
    let ids = this.form_group.get([this.form_control]).value;
    if (this.form_group) {
      this.form_group.get([this.form_control]).patchValue(ids ? 0 : 1);
      // this.change.emit(options);
      // console.log(this.form_group.get([this.form_control]).value);
    }
  }
  action(option) {
    try {
      if (this.actionListner) {
        this.actionListner(option);
      }
    }
    catch (err) {

    }
  }
}

